"use strict";
/**
 * Ось B — ПЛАТФОРМЕННАЯ ДОЛЖНОСТЬ (RBAC-1 AD-1).
 *
 * «Сотрудник платформы»: 0..n ролей, по умолчанию 0, назначает человек и редко.
 * Ось B — единственная, где имя роли законно участвует в решении о доступе: у
 * платформенного админа членств НЕТ и не будет (RBAC-1.3 Р-6), поэтому его ветка
 * не может прийти из членства и обязана прийти из имени.
 *
 * Здесь перечислены ВСЕ живые имена — включая те, у которых сегодня нет ни одного
 * гейта (`content_manager`, `moderator`, `merchant`, `readonly`, `test_perf_role`).
 * Словарь описывает то, что лежит в базе, а не то, что кто-то проверяет: роль без
 * гейта — не повод молчать о её существовании, иначе сторож AC-8 начнёт краснеть на
 * правде.
 *
 * ⚠ Судьба мёртвых ролей (`merchant`, `readonly`, `test_perf_role`, `moderator`) —
 * не здесь: их удаление в §9 эпика (RBAC-2). Этот файл их ОБЪЯВЛЯЕТ, потому что они
 * существуют.
 *
 * ⚠ Фантомов здесь нет и не будет. `platform_admin`, `merchant_owner`,
 * `merchant_manager`, `merchant_staff`, `merchant_operator` не существуют ни на dev,
 * ни на проде — снято запросом к обеим базам 2026-08-27. Имя-фантом в гейте не
 * отказывает и не пускает: решение принимает то, что осталось в списке рядом.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLATFORM_ADMIN_ROLE_NAMES = exports.PLATFORM_ROLE_VALUES = exports.PLATFORM_ROLES = void 0;
exports.isPlatformAdmin = isPlatformAdmin;
exports.PLATFORM_ROLES = {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'admin',
    SUPPORT: 'support',
    MODERATOR: 'moderator',
    CONTENT_MANAGER: 'content_manager',
    CATALOG_ADMIN: 'catalog_admin',
    READONLY: 'readonly',
    /** Роль эпохи «мерчант = имя роли»; прав не несёт, держателей на проде 0. */
    MERCHANT: 'merchant',
    /** Фикстура нагрузочных прогонов; держит одно право `test_perf:check`. */
    TEST_PERF_ROLE: 'test_perf_role',
};
exports.PLATFORM_ROLE_VALUES = Object.values(exports.PLATFORM_ROLES);
/**
 * «Платформенный админ» — ОДНО объявление на всю платформу.
 *
 * До RBAC-1.9 этот набор был выписан руками в шести местах, и в четырёх из них вторым
 * именем стоял фантом `platform_admin`. Следствия расходились: гейт 16 админских
 * маршрутов Core сужался до одного `super_admin` (хотя роутером выше уже пущен
 * `admin`), `super_admin` не видел `admin_only` категорий в каталоге, а ops-алерт о
 * провале провижининга не доходил до `admin`. Три разных поведения из одной опечатки —
 * потому что копий было шесть.
 *
 * ⚠ AD-10 — набор `['super_admin', 'admin']` есть РЕШЕНИЕ оператора (2026-08-27), а не
 * орфография. Гейт всегда обещал «платформенный админ», и gateway на тех же путях уже
 * пускает `admin` (`required_roles: [admin, super_admin]` во всех 77 записях); после
 * правки два слоя enforcement перестают утверждать разное. Цена сегодня нулевая:
 * держателей `admin` на проде 0, на dev 1.
 */
exports.PLATFORM_ADMIN_ROLE_NAMES = [
    exports.PLATFORM_ROLES.SUPER_ADMIN,
    exports.PLATFORM_ROLES.ADMIN,
];
/** Держит ли этот набор ролей платформенного админа. */
function isPlatformAdmin(roles) {
    if (!roles)
        return false;
    return roles.some((role) => exports.PLATFORM_ADMIN_ROLE_NAMES.includes(role));
}
